import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ListingApprovalService {
  constructor(private api: ApiService) {}

  getCommentsOnListingApproval(listingId: string) {
    return this.api.get(`/listing-approval/comments/${listingId}`);
  }

  saveCommentsOnListingApproval(payload: any) {
    return this.api.post(`/listing-approval/comments`, payload);
  }

  getHistoryDetailsOnListingApproval(listingId: string, pageNo = 1, perPage = 10, keyword = '') {
    return this.api.get(`/listing-approval/history/${listingId}?page=${pageNo}&per_page=${perPage}&keyword=${keyword}`);
  }

  getAllowedPermissionListOnListingApproval(listingId: string) {
    return this.api.get(`/listing-approval/permissions-by-listing/${listingId}?office_id=${this.api.getOfficeId()}`);
  }

  getListingApproval() {
    return this.api.get('/listing-approval/permissions/' + this.api.getUserId() + '?office_id=' + this.api.getOfficeId());
  }

  saveListingApproval(payload: any) {
    return this.api.post(`/listing-approval/permissions`, payload);
  }

  up_dateListingApprovalStatus(payload: any) {
    return this.api.post('/listing-approval', payload);
  }
  getListingApprovalTab() {
    return this.api.get(`/listing/approval-tab-count?user_id=${this.api.getUserId()}&office_id=${this.api.getOfficeId()}`);
  }
}
